import React from 'react'
import RoutedWizard from 'core/routing/routed-wizard'
import { TRADEIN } from 'core/routing/constants'

import TradeIn from '.'

export default (
  <RoutedWizard path={TRADEIN} isTradeIn>
    {TradeIn}
  </RoutedWizard>
)
